import uniqid from "uniqid";

import getAcceptedArtifactFiles from "../../src/api/artifacts/getAcceptedArtifactFiles";
import productionStatuses from "../../src/api/productions/constants/productionStatuses";

import createDocumentIdAndRef from "./createDocumentIdAndRef";
import createStorageFile from "./createStorageFile";

export default async function createEbookArtifact({ api, env }, { production, article }) {
	const bucketName = env === "live" ? "earselect-static" : "stage-earselect-static";
	if (!production.deliveryEbook.path) {
		throw new Error("Could not find any ebook on the production!");
	}
	const [{ updated, ...metadata }] = await api[env].getStorageMetadata(bucketName, production.deliveryEbook.path);

	const epub = await createStorageFile({
		file: {
			id: uniqid(),
			name: `${production.deliveryEbook.isbn || production.title}${
				getAcceptedArtifactFiles()[metadata.contentType][0]
			}`,
			fullPath: production.deliveryEbook.path,
			url: Array.isArray(production.deliveryEbook.url)
				? production.deliveryEbook.url[0]
				: production.deliveryEbook.url, // for some reason the url is sometimes in an array
			size: Number(metadata.size),
		},
		metadata,
	});

	const { id, ref } = createDocumentIdAndRef({ api, env }, { collection: "artifacts" });

	const created = metadata.timeCreated ? new Date(metadata.timeCreated) : null;

	return {
		id,
		ref,
		article:
			production.status === productionStatuses.DONE || api.isFinalizing ? (article?.isbn ? article : null) : null,
		files: [epub],
		name: production.title,
		size: epub.size,
		created,
		updated: created,
	};
}
